import { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

const RAW_BASE = process.env.REACT_APP_API_BASE || '/api';
const API_BASE = RAW_BASE.replace(/["']/g, '').replace(/\/+$/, '');

export default function ExamLauncher() {
  const { examId } = useParams();
  const [searchParams] = useSearchParams();
  const assignmentId = searchParams.get('assignmentId');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!examId) {
      console.warn('⚠️ No examId found. Redirecting to dashboard.');
      navigate('/student/dashboard');
      return;
    }

    console.log(`🔍 ExamLauncher started | examId: ${examId} | assignmentId: ${assignmentId}`);

    fetch(`${API_BASE}/student/exams/${examId}/metadata`)
      .then(res => {
        if (!res.ok) throw new Error(`Server responded with ${res.status}`);
        return res.json();
      })
      .then(data => {
        console.log('✅ Metadata received:', data);
        
        // ✅ Preserve assignmentId in redirect URL
        const query = assignmentId ? `?assignmentId=${assignmentId}` : '';
        
        // 🎯 ROUTING LOGIC: Diagnostic Math → Flow Builder → Standard
        if (data.exam_topic === 'math' && data.is_diagnostic) {
          navigate(`/student/math-diagnostic/${examId}?assignmentId=${assignmentId}`, { replace: true });
        }
        else if (data.is_flow_exam) {
          console.log(`🔄 Redirecting to Band Progression Player ${query}`);
          navigate(`/student/band-exam/${examId}${query}`, { replace: true });
        } 
        else {
          console.log(`🔄 Redirecting to Standard Player ${query}`);
          navigate(`/student/exam-player/${examId}${query}`, { replace: true });
        }
      })
      .catch(err => {
        console.error('❌ ExamLauncher error:', err);
        setError(`Unable to load exam: ${err.message}`);
        setTimeout(() => navigate('/student/dashboard'), 3000);
      })
      .finally(() => setLoading(false));
  }, [examId, assignmentId, navigate]);

  if (loading) return <div style={{ textAlign: 'center', marginTop: 80, fontSize: 16, color: '#666' }}>⏳ Preparing exam environment...</div>;
  if (error) return <div style={{ textAlign: 'center', marginTop: 80, padding: 20, background: '#f8d7da', borderRadius: 8, color: '#721c24' }}>❌ {error}</div>;
  
  return null;
}